import * as TYPES from './hamburgareTypes';

export const toggle = (show = false) => {
  return dispatch => {
    dispatch({ type: TYPES.HAMBURGARE_TOGGLE, show });
  };
};
